import { RESULT } from '../constants';

export default function deriveOperationResult(batch = {}) {
  const { status } = batch;
  if (status === RESULT.queued || status === RESULT.running) {
    return status;
  }
  if (status === RESULT.failed) {
    return RESULT.failed;
  }

  const failed = batch.failed || 0;
  const succeeded = batch.succeeded || 0;
  const warnings = batch.warnings || 0;

  if (failed > 0 && (succeeded > 0 || warnings > 0)) {
    return RESULT.partial_failure;
  }
  if (failed > 0 && succeeded === 0 && warnings === 0) {
    return RESULT.failed;
  }
  if (failed === 0 && warnings > 0) {
    return RESULT.warnings;
  }
  return RESULT.success;
}

export function isInFlightResult(result) {
  return result === RESULT.queued || result === RESULT.running;
}
